import type { OptionChoices } from "building-types/options/optionChoices";
import { archetypeOnlyOptions } from "building-types/options/optionDefinitions";
import type { DocOptionSet } from "building-types/options/optionSet";
import type { Table } from "common/data/table";
import { optionSetSelectedOptionId } from "doc/options/optionSetTools";
import { SystemOptionSet } from "./SystemOptionSetEnum";

export function buildingIsMirrored(optionSets: Table<DocOptionSet>, optionChoices: OptionChoices): boolean {
  return optionSetSelectedOptionId(archetypeOnlyOptions(optionSets), optionChoices, SystemOptionSet.MIRROR) === "true";
}
